import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownRendererProps {
	content: string;
	isTyping?: boolean;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content, isTyping }) => (
	<div style={{ fontSize: '13px', lineHeight: '1.5' }}>
		<ReactMarkdown
			remarkPlugins={[remarkGfm]}
			components={{
				a: ({ href, children, ...props }) => (
					<a
						href={href}
						target="_blank"
						rel="noopener noreferrer"
						style={{ color: '#0073bb' }}
						{...props}
					>
						{children}
					</a>
				),
				table: ({ children, ...props }) => (
					<table
						style={{
							borderCollapse: 'collapse',
							width: '100%',
							margin: '8px 0',
							fontSize: '12px',
						}}
						{...props}
					>
						{children}
					</table>
				),
				th: ({ children, ...props }) => (
					<th
						style={{
							border: '1px solid #d1d5db',
							padding: '6px 8px',
							backgroundColor: '#f3f4f6',
							fontWeight: 600,
							textAlign: 'left',
						}}
						{...props}
					>
						{children}
					</th>
				),
				td: ({ children, ...props }) => (
					<td
						style={{
							border: '1px solid #d1d5db',
							padding: '6px 8px',
						}}
						{...props}
					>
						{children}
					</td>
				),
			}}
		>
			{content}
		</ReactMarkdown>
		{isTyping && (
			<span
				data-testid="typing-cursor"
				style={{
					display: 'inline-block',
					width: '6px',
					height: '14px',
					backgroundColor: '#0073bb',
					marginLeft: '2px',
					animation: 'blink 1s step-end infinite',
					verticalAlign: 'text-bottom',
				}}
			/>
		)}
	</div>
);

export default MarkdownRenderer;
